import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-356e9045"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "exportation-fields" };
const _hoisted_2 = { class: "exportation-fields__header" };
const _hoisted_3 = { class: "exportation-fields__title" };
const _hoisted_4 = { class: "exportation-fields__grid" };
const _hoisted_5 = ["onClick"];
const _hoisted_6 = { class: "exportation-fields__text" };
const _hoisted_7 = { class: "exportation-fields__name" };
const _hoisted_8 = { class: "exportation-fields__key" };
import CheckBox from '@/components/_atoms/CheckBox.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ExportationFields',
    props: {
        columns: {},
        selectedColumnsKeys: {}
    },
    emits: ["toggle", "clear"],
    setup(__props, { emit }) {
        const props = __props;
        const toggleSelection = (key) => {
            emit('toggle', key);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("header", _hoisted_2, [
                    _createElementVNode("h3", _hoisted_3, [
                        _createTextVNode(_toDisplayString(_ctx.$tc('field', 0)) + " ", 1),
                        _createElementVNode("button", {
                            class: "exportation-fields__clear-btn",
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (emit('clear')), ["prevent"]))
                        }, _toDisplayString(_ctx.$t('audiences.exportation.clear-selections')), 1)
                    ])
                ]),
                _createElementVNode("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.columns, (column) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: column.key,
                            class: "exportation-fields__item",
                            onClick: _withModifiers(($event) => (toggleSelection(column.key)), ["prevent"])
                        }, [
                            _createVNode(CheckBox, {
                                checked: props.selectedColumnsKeys.includes(column.key)
                            }, null, 8, ["checked"]),
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("span", _hoisted_7, _toDisplayString(column.name), 1),
                                _createElementVNode("span", _hoisted_8, _toDisplayString(column.key), 1)
                            ])
                        ], 8, _hoisted_5));
                    }), 128))
                ])
            ]));
        };
    }
});
